import { AxiosPromise } from "axios";
import { request } from "utils/request";


export const popupApi = {
  findAll: (params?: any): AxiosPromise<any> => request({
    url: `/v1/admin/popup`,
    params
  }),
  create: (data: any): AxiosPromise<any> => request({
    url: `/v1/admin/popup`,
    data,
    method: 'post'
  }),
  update: (id: number, data: any): AxiosPromise<any> => request({
    url: `/v1/admin/popup/${id}`,
    method: 'patch',
    data
  }),
  delete: (id: number): AxiosPromise<any> => request({
    url: `/v1/admin/popup/${id}`,
    method: 'delete'
  }),
  show: (id: number): AxiosPromise<any> => request({
    url: `/v1/admin/popup/${id}/show`,
    method: 'patch',
  }),
  hide: (id: number): AxiosPromise<any> => request({
    url: `/v1/admin/popup/${id}/hide`,
    method: 'patch',
  }),
}
